const Logout = () => {
  window.location.href = "/login";
};

export default Logout;
